import { defineComponent as _defineComponent } from 'vue'
import { parseDecimal } from '@/utils/string';
import { onMounted, ref } from 'vue';

import {
  getSection8JSOHCategoryDustList,
  getSection8JSOHCategoryDustRespirableList,
  getSection8JSOHCategoryConcentrationList,
} from '@/lib/formItem';
import { isFloatOrNull } from '@/lib/rule';
import { VForm } from 'vuetify/lib/components';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsSection8JSOHForm',
  props: {
    isEditing: { type: Boolean },
    isValid: { type: Boolean },
    categoryConcentrationId: null,
    categoryDustId: null,
    categoryDustRespirableId: null,
    concentration: null,
    concentrationUnit: null,
    concentrationNote: null,
    amount: null,
    amountUnit: null,
    amountNote: null,
    other: null
  },
  emits: ["update:isValid", "update:categoryConcentrationId", "update:categoryDustId", "update:categoryDustRespirableId", "update:concentration", "update:concentrationUnit", "update:concentrationNote", "update:amount", "update:amountUnit", "update:amountNote", "update:other"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:isValid', data: boolean): void;
  (e: 'update:categoryConcentrationId', data: number): void;
  (e: 'update:categoryDustId', data: number): void;
  (e: 'update:categoryDustRespirableId', data: number): void;
  (e: 'update:concentration', data: number | null): void;
  (e: 'update:concentrationUnit', data: string): void;
  (e: 'update:concentrationNote', data: string): void;
  (e: 'update:amount', data: number | null): void;
  (e: 'update:amountUnit', data: string): void;
  (e: 'update:amountNote', data: string): void;
  (e: 'update:other', data: string): void;
}), expose: any, slots: any, attrs: any }) {



const form = ref<InstanceType<typeof VForm> | null>(null);



const updateIsValid = (e: boolean): void => {
  emits('update:isValid', e);
};

const updateCategoryConcentrationId = (e: number): void => {
  emits('update:categoryConcentrationId', e);
};

const updateCategoryDustId = (e: number): void => {
  emits('update:categoryDustId', e);
};

const updateCategoryDustRespirableId = (e: number): void => {
  emits('update:categoryDustRespirableId', e);
};

const updateConcentration = (e: string | null): void => {
  emits('update:concentration', parseDecimal(e));
};

const updateAmount = (e: string | null): void => {
  emits('update:amount', parseDecimal(e));
};

const updateOther = (e: string): void => {
  emits('update:other', e);
};

onMounted((): void => {
  if (form.value) {
    form.value.validate();
  }
});

return { __sfc: true,form, emits, updateIsValid, updateCategoryConcentrationId, updateCategoryDustId, updateCategoryDustRespirableId, updateConcentration, updateAmount, updateOther, getSection8JSOHCategoryDustList, getSection8JSOHCategoryDustRespirableList, getSection8JSOHCategoryConcentrationList, isFloatOrNull, VForm, sharedMessages }
}

})